import Script from 'next/script'
import {FC} from 'react'

import {gtmContainerSrc} from '@/utils/tracking/ga'

// The GTM container is ~539 kB and drives only the ad-pixel layer (Meta, Bing, Reddit, Quora,
// LinkedIn). None of it has to run during page load, so the fetch is deferred to browser idle
// after the window `load` event. GA4 and Mixpanel are injected separately by `initAnalytics`
// and keep their current timing, so funnel analytics and bounce measurement are unaffected.
//
// Deferring is loss-free for everything this app pushes: `window.dataLayer` is created eagerly
// in `initGoogleAnalytics`, events accumulate in it, and GTM replays them in order on arrival -
// with the `gtm.js` message pinned first so base tags always run before their event tags.
//
// Two things it does NOT cover, both container-side:
//  - GTM-native interaction triggers (click, scroll depth, element visibility, form submit)
//    install their listeners when the container loads, so interactions before that are never
//    observed. Any conversion depending on one must move to an `analytics.track()` call, which
//    pushes to `dataLayer` and therefore queues safely.
//  - A visitor who leaves before `load` fires sends nothing at all. That gap is inherent to
//    deferring and is the intended trade: those sessions are pre-bounce.
export const GoogleTagManager: FC = () =>
  gtmContainerSrc ? <Script src={gtmContainerSrc} strategy="lazyOnload" /> : null
